import { formatNumber } from "@/utils/helpers";

// The API answers with the totals row, possibly inside the response envelope; its keys are camelized.
const unwrap = (response) => {
  let current = response;
  while (current?.data && typeof current.data === "object" && !Array.isArray(current.data)) {
    current = current.data;
  }
  return current || {};
};

const agingTiles = [
  { key: "balanceTotal", label: "Total Outstanding", highlight: true },
  { key: "invoices", label: "Invoices", isCount: true },
  { key: "amountTotal", label: "Amount" },
  { key: "paidTotal", label: "Paid" },
  { key: "oneMonthTotal", label: "0-30 Days" },
  { key: "twoMonthTotal", label: "31-60 Days" },
  { key: "threeMonthTotal", label: "61-90 Days" },
  { key: "over91DaysTotal", label: "91-121 Days", late: true },
  { key: "over122DaysTotal", label: "122-365 Days", late: true },
  { key: "over365DaysTotal", label: "Above 365 Days", late: true },
];

/**
 * Compact totals above a report. By default the customer aging tiles: the outstanding balance,
 * how many invoices make it up, and the balance in each aging bucket (the buckets always add up
 * to the outstanding balance). Other reports pass their own tiles, keyed by their summary
 * endpoint's camelized columns.
 */
export default function AgingSummary({ summary, tiles = agingTiles }) {
  const totals = unwrap(summary);

  return (
    <div className="aging-summary">
      {tiles.map(({ key, label, highlight, isCount, late }) => {
        const value = Number(totals[key] || 0);
        const classes = [
          "aging-summary-tile",
          highlight ? "highlight" : "",
          late && value > 0 ? "late" : "",
        ].join(" ").trim();

        return (
          <div className={classes} key={key}>
            <div className="aging-summary-value">
              {isCount ? value.toLocaleString("en-US") : formatNumber(value)}
            </div>
            <div className="aging-summary-label">{label}</div>
          </div>
        );
      })}
    </div>
  );
}
